module.exports = __webpack_public_path__ + "static/media/School_Payments.822174c8.svg";